import React from "react";
import { CloseIcon } from "@/componentsUI/Icon";
import styles from "./PopupCloseButton.module.less";

interface PopupCloseButtonProps {
  onClose: () => void;
  className?: string;
}

/**
 * 通用弹窗关闭按钮组件
 * 可在各种弹窗中复用的关闭按钮
 */
const PopupCloseButton: React.FC<PopupCloseButtonProps> = ({
  onClose,
  className,
}) => {
  return (
    <CloseIcon
      className={`${styles.closeButton} ${className || ""}`}
      onClick={onClose}
    />
  );
};

export default PopupCloseButton;
